module.exports = __webpack_public_path__ + "b7dfd56e5563bb807479481c9340844c.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-confirm/sp-confirm.html
// module id = 1099
// module chunks = 0